import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { upsertStockFee } from "../thunks/upsertStockFee";
import { setFetchState } from "../stockFeesDataReducer";
import { StockFee } from "../types";

export const useStockFeeUpsert = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (store) => store.data.clearing.stockfees.fetchState
  );

  const dispatch = useDispatch();
  const dispatchUpsertStockFee = React.useCallback(
    (stfee: StockFee) => dispatch(upsertStockFee(stfee)),
    [dispatch]
  );

  React.useEffect(() => {
    dispatch(setFetchState({ type: "not-started" }));
  }, [dispatch]);

  return [fetchState, dispatchUpsertStockFee] as [
    typeof fetchState,
    typeof dispatchUpsertStockFee
  ];
};
